import { defineMessages } from 'react-intl-next';

export const messages: {
	controlKey: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	googleCalendarLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	controlKey: {
		id: 'dynamic-cards-search-page.icons.control-key',
		defaultMessage: 'Ctrl',
		description: 'Label for the Control keyboard key',
	},
	googleCalendarLabel: {
		id: 'dynamic-cards-search-page.icons.google-calendar-label',
		defaultMessage: 'Google Calendar',
		description: 'Accessibility label for the Google Calendar icon',
	},
});
